import { BYSTANDERS } from './bystanders';
import { DASH } from './dash';
import { CLASSES } from './classes';
import { ENEMIES } from './enemies';
import { FULL_PATHS, FULL_SUMMONS } from './full';
import { FUSIONS } from './fusions';
import { SETS } from './sets';
import { TRAPS } from './traps';
import { TUTORIAL } from './tutorial';
import type { GameContent } from './types';
import { RARITY_WEIGHTS, UPGRADES } from './upgrades';
import { WEAPONS } from './weapons';

export const CONTENT: GameContent = {
  classes: CLASSES,
  enemies: ENEMIES,
  traps: TRAPS,
  upgrades: UPGRADES,
  sets: SETS,
  bystanders: BYSTANDERS,
  weapons: WEAPONS,
  fusions: FUSIONS,
  rarityWeights: RARITY_WEIGHTS,
  dash: DASH,
  paths: FULL_PATHS,
  summons: FULL_SUMMONS,
  tutorial: TUTORIAL,
};
